import { Validation } from './Validation';

export default interface WorkshopPriceJson {
   /**
    * Name des Preises.
    */
   title: string;

   /**
    * Besondere Hinweise, die für diesen Preis oder diese Vergünstigung gelten. Kann ein leerer String sein wenn nichts besonderes gilt.
    */
   remarks: string;

   /**
    * Stornierungsgebuer in Eurocent.
    */
   cancellationFee: number,

   /**
    * Stornierungsbedingungen.
    */
   cancellationRemarks: string,

   /**
    * Preis pro Teilnehmer für dieses Programm in Eurocent der als Anzahlung fällig ist.
    */
   priceDeposit: number,

   /**
    * Preis pro Teilnehmer für dieses Programm in Eurocent der nicht als Anzahlung fällig ist. 
    * Der Gesamtpreis des Kurses pro Teilnehmer ist participantDepositPrice + participantNonDepositPrice
    */
   priceNonDeposit: number,
}

export function validateWorkshopPriceJson(item: WorkshopPriceJson) {
   return new Validation(item)
      .validateNonEmptyString("title", 100)
      .validateString("remarks", 500)
      .validateInteger("cancellationFee", 0)
      .validateString("cancellationRemarks", 500)
      .validateInteger("priceDeposit", 0)
      .validateInteger("priceNonDeposit", 0)
      .finish();
}